import { Anchor, Image } from "@mantine/core";
import { getPresentationParamsForOrigin } from "../getPresentationParamsForOrigin.ts";

export const SponsorAd = () => {
  const ad = getPresentationParamsForOrigin().ads?.banner?.[0];

  if (!ad) {
    return null;
  }

  return (
    <Anchor href={ad.linkUrl} target="_blank" rel="noopener noreferrer">
      <Image src={ad.imageUrl} alt="" />
    </Anchor>
  );
};
